export default __webpack_public_path__ + "static/media/grayborder.45dd2299.svg";